const GRID_INTERVAL = 2 // grid interval should be inversely propotional to the thing being placed
const CANVAS_SIZE = 1000
const GRID_SIZE = CANVAS_SIZE / GRID_INTERVAL
const WORLD_SIZE = GRID_SIZE * GRID_SIZE
const RND_SEED = 129
const REZ = 0.09 // lower = bigger groups
const NOISE_OFFSET = 0
const COLLISION_CHECK_INTERVAL = 10// gap between shape size to check
const PALLET_SIZE = 30 // how many steps to break the pallet into
const MIN_DISTORTION = 1 // minumum distortion of polygons allowed
const MAX_DISTORTION = 1.005 // minumum distortion of polygons allowed

const FG_MOVE_REZ = 0.001
const BG_MOVE_REZ = 0.001
const BG_SCALE_REZ = 0.1
const FG_SCALE_REZ = 0.1
const PALLET_REZ = 3

const DRAW_PER_TICK = 10

const DRAW_MODE = {
  FILL: 0,
  SHAPE: 1
}

const SHAPES = {
  LINE: [[-0.2,-0.8],[0.2,-0.8],[0.2,0.8],[-0.2,0.8],[-0.2,-0.8]],
  LITTLE_SQUARE: [[-0.2,-0.2],[-0.2,0.2],[0.2,0.2],[0.2,-0.2],[-0.2,-0.2]],
  LIGHTNING: [[0,-1],[-0.8,-0.2],[-0.4,-0.2],[-0.8,0.8],[0.2,-0.2],[-0.2,-0.2],[0,-1]],
  EXCLAMATION: [[-0.3,0.4],[-0.3,-0.8],[0.1,-0.8],[0.1,0.4],[-0.3,0.4],[-0.3,0.6],[0.1,0.6],[0.1,1],[-0.3,1],[-0.3,0.6]],
  PLUS: [[-0.2,-0.8],[0.2,-0.8],[0.2,-0.2],[0.8,-0.2],[0.8,0.2],[0.2,0.2],[0.2,0.8],[-0.2,0.8],[-0.2,0.2],[-0.8,0.2],[-0.8,-0.2],[-0.2,-0.2],[-0.2,-0.8]],
  '@': [[-0.8,-0.8],[0.8,-0.8],[0.8,0.8],[0.4,0.8],[0.4,-0.4],[-0.4,-0.4],[-0.4,0.4],[-0.2,0.4],[-0.2,0],[0.2,0],[0.2,0.8],[-0.8,0.8],[-0.8,-0.8]],
  HOLLOW_SQUARE: [[0.1,0.1],[0.9,0.1],[0.9,0.9],[0.1,0.9],[0.1,0.7],[0.7,0.7],[0.7,0.3],[0.3,0.3],[0.3,0.7],[0.1,0.7],[0.1,0.1]],
  ARROW: [[0.5,0.05],[0.05,0.5],[0.3,0.5],[0.4,0.4],[0.4,0.9],[0.6,0.9],[0.6,0.4],[0.7,0.5],[0.95,0.5],[0.5,0.05]],
  TRIANGLE: [[0,-1],[-1,1],[1,1],[0,-1],[-0.2,-0.6],[0.4,0.6],[-0.4,0.6],[0.2,-0.6]],
}

export {
    GRID_INTERVAL,
    COLLISION_CHECK_INTERVAL,
    PALLET_REZ,
    PALLET_SIZE,
    REZ,
    FG_MOVE_REZ,
    BG_MOVE_REZ,
    FG_SCALE_REZ,
    BG_SCALE_REZ,
    RND_SEED,
    SHAPES,
    DRAW_PER_TICK,
    DRAW_MODE,
    CANVAS_SIZE
}